"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatSignalHelper = void 0;
class ChatSignalHelper {
    static workWithSignals() {
        // Get or create the signals using simplified getSignal
        this.conversationSignal = this.signalService.getSignal('selected_conversation', { initialValue: null });
        this.modelSignal = this.signalService.getSignal('selected_model', { initialValue: null });
        this.navBarSignal = this.signalService.getSignal('nav_bar', { initialValue: null });
        this.navBarSignal.setValue({ showChatControls: true });
        // Subscribe to conversation changes from nav-bar
        this.signalSubscriptions.push(this.conversationSignal.value$.subscribe(conversation => {
            this.handleConversationChange((conversation === null || conversation === void 0 ? void 0 : conversation.conversation) || null, conversation === null || conversation === void 0 ? void 0 : conversation.frontMessages, (conversation === null || conversation === void 0 ? void 0 : conversation.isNew) || false);
        }));
        // Subscribe to model changes from nav-bar
        this.signalSubscriptions.push(this.modelSignal.value$.subscribe(selectedModel => {
            if (selectedModel && this.shouldUpdateModel(selectedModel)) {
                this.handleModelChange(selectedModel);
            }
        }));
    }
}
exports.ChatSignalHelper = ChatSignalHelper;
